import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import {Grid, InputBase} from '@material-ui/core';
import { TextFieldComponent, DatePickerComponent, TextFieldWithSelectComponent, Select2Component, SelectComponent, TextAreaComponent } from '../../components/FormElement';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import DividerCustom from '../../components/Divider'
import validators from '../../utils/validators';
import ButtonCustom from '../../components/ButtonCustom';
import { Field, Form } from 'react-final-form';
const drawerWidth = 520;
const styles = theme => ({
    button: {
        marginTop: theme.spacing(8)
    },
    form:{
        marginTop: theme.spacing(16)
    }
});

function NewServiceRequestView(props) {
    const { classes, t, request_info, showLoading, onSelectQueue, onCreate, queues } = props;
    console.log('setQueues item= ', queues)
    //console.log("profile======== ", profileName)
    return (
        <div>
            <DrawerCustom
                open={props.open}
                onClose={props.onClose}
                title = {t('new_service_request')}
                children={
                    <Grid item >
                        <Grid item container justify='center' alignItems='center'>
                            {showLoading&&<CustomizedCircularProgress/>}
                        </Grid>
                        <Form
                            onSubmit={onCreate}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item justify='center' className={classes.form}>
                                    {/* <Grid xs={12} item container>
                                        <Field
                                            name="title"
                                            component={TextFieldComponent}
                                            label={t('title')}
                                            defaultValue={service_request.title}
                                            isEdit={true}
                                            color='default'
                                            validate={validators.composeValidators(validators.required)}
                                        />
                                    </Grid> */}

                                    <Grid xs={12} item container>
                                        <Field
                                            name="classification_id"
                                            component={SelectComponent}
                                            label={t('classification')}
                                            selectData={props.queues}
                                            //defaultValueSelect={address_types[0].value}
                                            valueSelect={request_info.queue_id?request_info.queue_id:null}
                                            onSelectedChange={(event)=>onSelectQueue(event.target)}
                                            color='default'
                                            placeholder = {t('Select')}
                                            isEdit={true}
                                            />
                                    </Grid>

                                    <Grid xs={12} item container>
                                        <Field
                                            name="description"
                                            component={TextAreaComponent}
                                            label={t('description')}
                                            isEdit={true}
                                            color='default'
                                            labelColor='default'
                                            defaultValue={request_info.description}
                                            //onCustomChange={handleChange}
                                            multiline
                                            validate={validators.composeValidators(validators.required)}
                                        //onChange={(text) => this.props.onHandleChange('first_name', text)}
                                        />
                                    </Grid>
            
                                    <Grid xs={12} item container justify='center' className={classes.button}>
                                        <ButtonCustom color='primary' fullWidth onClick={handleSubmit}>{t('btn_submit')}</ButtonCustom>
                                    </Grid>
                                </Grid>
                            )} /> 
                </Grid>}/>

        </div>
    );
}

export default withStyles(styles)(withTranslation()(NewServiceRequestView));